import { z } from 'zod';
import { TASK_PRIORITY, TASK_STATUS } from '../../../../constnats/task';
import { taskCreationSchema, TaskType, taskUpdateSchema } from '../../../../schemas/task.schemas';
import AuthService from '../../../../service/auth';

export const taskFormSchema = taskCreationSchema.merge(taskUpdateSchema).extend({
    taskId: z.number().int().nonnegative(),
});
export type TaskFormSchemaType = z.infer<typeof taskFormSchema>;

export function getTaskFormDefaultState(task?: Partial<TaskType>): TaskFormSchemaType {
    return {
        taskId: task?.id || 0,
        title: task?.title || '',
        description: task?.description || '',
        assignedUserId: task?.assignedUserId || null,
        priority: task?.priority || TASK_PRIORITY.LOW,
        dueDate: task?.dueDate || new Date().toISOString(),
        status: task?.status || TASK_STATUS.NOT_STARTED,
        createdById: task?.createdByUserId ?? AuthService.getUserId(),
    };
}
